import { Link } from "react-router-dom";

const JobsDev = () => {
    return (
    <>

    <div class="breadcrumb">
        <span class="caret">&gt;</span>
        <span class="link"><Link to="/jobs">Work Opportunities</Link></span>
        <span class="caret">&gt;</span>
        <span class="current">Software Developer</span>
    </div>

    <h1>Software Developer</h1>

    <div class="wpb_wrapper">

    <strong><font color="#2272FF">Job Description:</font></strong> 
    <p></p>
    We are looking for a talented and experienced Software Developer to join our growing team. As a Software Developer at Saigon AI, you will play a key role in designing, developing, and deploying high-quality software solutions that drive our customer’s initiatives. This role requires a strong foundation in software development, a passion for innovation, and a collaborative mindset.
 <p></p>
    <strong><font color="#2272FF">Key Responsibilities:</font></strong>
    <p></p>
    <ul>
        <li>Design, develop, test, and maintain scalable software applications and systems.</li>
        <li>Collaborate with cross-functional teams, including data scientists and product managers, to define software requirements and deliverables.</li>
        <li>Write clean, efficient, and maintainable code following best practices and coding standards.</li>
        <li>Troubleshoot and debug issues across the development lifecycle to ensure optimal performance and user experience.</li>
        <li>Participate in code reviews, provide feedback to peers, and contribute to improving the overall codebase quality.</li>
        <li>Work with cloud platforms, APIs, and databases to integrate and deploy software solutions.</li>
        <li>Stay up-to-date with the latest technologies, tools, and industry trends to continually enhance your skill set and improve our products.</li>
    </ul>
    <p></p>
    <strong><font color="#2272FF">Qualifications:</font></strong>
    <p></p>
    <ul>
        <li>Bachelor's degree in Computer Science, Software Engineering, or a related field.</li>
        <li>At least 1 year of professional experience in software development. Internships do not count as work experience.</li>
        <li>Proficiency in programming languages such as Python, Java, C++, or JavaScript.</li>
        <li>Experience with version control systems (e.g., Git) and collaborative development workflows.</li>
        <li>Strong problem-solving skills and the ability to work both independently and within a team environment.</li>
        <li>Solid understanding of software development principles, data structures, and algorithms.</li>

    </ul>
    <p></p>
    <strong><font color="#2272FF">A Plus:</font></strong>
    <p></p>
    <ul>
        <li>Familiarity with cloud platforms (e.g., AWS, Google Cloud) and containerization tools (e.g., Docker).</li>
        <li>Knowledge of database management systems, both SQL and NoSQL.</li>
        <li>Previous experience in an Agile development environment.</li>

    </ul>
    <p></p>
 <strong><font color="#2272FF">Benefits:</font></strong><p></p>
 <ul>
 <li>Salary will be discussed based on candidates' experience and ability.</li>
 <li>Work in a young, dynamic international company founded by experienced American entrepreneurs.</li>
 <li>Health insurance, Public holiday and Annual leave as per Vietnamese Labor law.</li>
 <li>Opportunity for growth and training.</li>
 <li>Experience an international business environment, which provides opportunities to improve Business English.</li>
 <li>Company Retreat once a year for full-time employees.</li>
 <li>Experience the unique harmony of Vietnamese - American Culture.</li>
 <li>Tea-times, Coffee Talk, I.T. English Club, sports activities, in-house games, etc.</li>
 <li>Personal coaching and career orientation.</li>
    </ul>

<div class="vc_separator wpb_content_element vc_separator_align_center vc_sep_width_100 vc_sep_pos_align_center vc_separator_no_text vc_sep_color_grey">
<span class="vc_sep_holder vc_sep_holder_l">
    <span class="vc_sep_line"></span>
</span>
<span class="vc_sep_holder vc_sep_holder_r">
    <span class="vc_sep_line"></span>
</span>
</div>
</div>

<Link to="/jobs/process" class="btn btn-warning">How To Apply</Link>


    </>
    )
  };
  export default JobsDev;